export default function getAuthyQrReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GET_AUTHY_QR_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_AUTHY_QR_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_AUTHY_QR_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}